import { Action } from "redux";

import { HashMap } from "../../shared/model/HashMap";
import { IProcessReferenceData, Process } from "../model/Process";
import * as FetchActions from "../actions/FetchActions";
import * as SignalRActions from "../actions/SignalRActions";
import * as ProcessActions from "../actions/ProcessActions";
import { LogRetentionUsageData, LogLevelUsageData } from "processList/model/LogLevelAndRetentionUsageModel";

export function processCount(state = 0, action: Action): number {
    switch (action.type) {
        case FetchActions.RECEIVE_PROCESSES:
            return (action as FetchActions.ReceiveProcessesAction).processCount;
        default:
            return state;
    }
}

export function processes(state: Process[] = [], action: Action): Process[] {
    switch (action.type) {
        case FetchActions.RECEIVE_PROCESSES:
            return (action as FetchActions.ReceiveProcessesAction).processes;
        case SignalRActions.UPDATE_PROCESSES: {
            const updateAction = action as SignalRActions.UpdateProcessesAction;
            const updatedState: Process[] = new Array<Process>().concat(state);
            for (const process of updateAction.processes) {
                const foundIndex = updatedState.findIndex((p: Process) => p.uniqueIdentifier === process.uniqueIdentifier);
                // Only update process if it's found in the current visible processes
                if (foundIndex !== -1) {
                    updatedState[foundIndex] = process;
                }
            }
            return updatedState;
        }
        case SignalRActions.DELETE_PROCESSES: {
            const deleteAction = action as SignalRActions.ProcessesDeletedAction;
            return state.filter((process) => deleteAction.processIds.indexOf(process.uniqueIdentifier) === -1);
        }
        case ProcessActions.UPDATE_PROCESS_VARIABLES:
            const updateProcessVariablesAction = action as ProcessActions.UpdateProcessVariablesAction;
            const process = state.find((process) => updateProcessVariablesAction.processId === process.id)!;
            process.processVariables = updateProcessVariablesAction.processVariables;
            return state;
        default:
            return state;
    }
}

export function referencedProcessMap(state: HashMap<IProcessReferenceData[]> = {}, action: Action): HashMap<IProcessReferenceData[]> {
    switch (action.type) {
        case FetchActions.RECEIVE_SUBPROCESSES_USAGE_DATA: {
            const receiveAction = action as FetchActions.ReceiveSubprocessUsageDataAction;
            return receiveAction.data.processReferences;
        }
        default:
            return state;
    }
}

export function usedInProcessesMap(state: HashMap<HashMap<string[]>> = {}, action: Action): HashMap<HashMap<string[]>> {
    switch (action.type) {
        case FetchActions.RECEIVE_SUBPROCESSES_USAGE_DATA: {
            const receiveAction = action as FetchActions.ReceiveSubprocessUsageDataAction;
            return receiveAction.data.usedInProcesses;
        }
        default:
            return state;
    }
}
export function usedProcessesMap(state: HashMap<HashMap<string[]>> = {}, action: Action): HashMap<HashMap<string[]>> {
    switch (action.type) {
        case FetchActions.RECEIVE_SUBPROCESSES_USAGE_DATA: {
            const receiveAction = action as FetchActions.ReceiveSubprocessUsageDataAction;
            return receiveAction.data.usedProcesses;
        }

        default:
            return state;
    }
}

export const logLevelUsage = (state: LogLevelUsageData = {}, action: Action): LogLevelUsageData => {
    switch (action.type) {
        case FetchActions.RECEIVE_LOGLEVEL_USAGE_DATA: {
            const receiveAction = action as FetchActions.ReceiveLogLevelUsageDataAction;
            return receiveAction.data;
        }

        default:
            return state;
    }
}

export const logRetentionUsage = (state: LogRetentionUsageData = {}, action: Action): LogRetentionUsageData => {
    switch (action.type) {
        case FetchActions.RECEIVE_LOGRETENTION_USAGE_DATA: {
            const receiveAction = action as FetchActions.ReceiveLogRetentionDataAction;
            return receiveAction.data;
        }

        default:
            return state;
    }
}
